import { ShopRendererApiClient } from '@fourthwall/services/dist/ShopRendererApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useSocialLinksQuery = createQueryHook(ShopRendererApiClient.getSocialNetworks, {
  queryKey: ['socialLinks'],
})
